import React from 'react';
import axios from './../../../constants/axios';
import { Link } from 'react-router';
import moment from 'moment';
import alert from 'alertify.js';

class ProductSearch extends React.Component {
   constructor(props) {
      super(props);
      this.state = {
         products: [],
         inactive: false,
      };
   }

   componentDidMount() {
      axios.get('items/getAllProductsBySearch')
         .then((res) => {
            this.setState({
               products: res.data
            });
         });
   }

   searchProductByName = (e) => {
      // search for barcode. If found, push items
      this.setState({
         products: [],
      });
      return axios.get('items/getAllProductsBySearch', {
         params: {
            searchString: e.target.value,
            status: this.refs.status.value,
            showOnSite: this.refs.showOnSite.value,
         }
      })
         .then((res) => {
            this.setState({
               products: res.data,
            });
         })
         .catch(() => {
         });
   };

   searchProductByBarcode = (e) => {
      // search for barcode. If found, push items
      if (e.keyCode === 13 && e.target.value) {
         this.setState({
            products: [],
         });
         axios.get('items/getSearchByBarcode', {
            params: {
               barcode: e.target.value,
            }
         })
            .then((res) => {
               this.setState({
                  products: res.data,
               });
            })
            .catch(function (err) {
               alert.error(err.response.data);
            });
      }
   };


   render() {
      const mainRowStyle = {
         marginBottom: '10px',
         borderTop: '1px solid black',
         borderBottom: '1px solid black'
      };
      const subRowStyle = Object.assign({}, mainRowStyle, {
         marginLeft: '15px'
      });

      return (
         <div className="ProductSearch" >
            <h3 >Products By Searching</h3 >
            <span >
                           Barcode: <input ref="barcode" placeholder="Scan Barcode" type="text" name="barcode"
                                           onKeyDown={(e) => this.searchProductByBarcode(e)} />
            </span >
            <span >
                           Name Search: <input ref="nameSearch" placeholder="Search Products" type="text"
                                               name="nameSearch"
                                               onKeyDown={(e) => this.searchProductByName(e)} />
            </span >
            <span >
                  <label >Filter By Status</label >
               <select ref="status" >
                  <option value="" >All</option >
                  <option value="1" >Active</option >
                  <option value="0" >Inactive</option >
               </select >
            </span >
            <span >
                  <label >Show On Site Status</label >
               <select ref="showOnSite" >
                  <option value="" >All</option >
                  <option value="1" >Show</option >
                  <option value="0" >Hide</option >
               </select >
            </span >
            <hr />
            <div className="__products" >
               <div className="row" >
                  <h4 className="col-md-1" >Id</h4 >
                  <h4 className="col-md-5" >Name</h4 >
                  <h4 className="col-md-1" >Price</h4 >
                  <h4 className="col-md-1" >Discount</h4 >
                  <h4 className="col-md-1" >Status</h4 >
                  <h4 className="col-md-1" >SiteShow</h4 >
                  <h4 className="col-md-1" >Price Update</h4 >
                  <h4 className="col-md-1" >Actions</h4 >
               </div >
               {this.state.products.map((product) => (
                  <div key={product.id} className="top_row" >
                     <div className="row product_row" style={mainRowStyle} >
                        <div className="col-md-1" >{product.id}</div >
                        <div className="col-md-5" >{product.name}</div >
                        <div className="col-md-1" >{product.price}</div >
                        <div className="col-md-1" >{product.discount}</div >
                        <div className="col-md-1" >{product.active}</div >
                        <div className="col-md-1" >{product.show_on_site}</div >
                        <div className="col-md-1" >{moment(product.price_update_at).fromNow()}</div >
                        <div className="col-md-1" >
                           {" | "}
                           <Link to={`/product/productMain/${product.id}`} >details</Link >
                           {" | "}
                           <Link to={`/product/productMain/edit/${product.id}`} >edit</Link >
                           {" | "}
                        </div >
                     </div >
                     {
                        product.subProducts ?
                           product.subProducts.map((s) => (
                              <div key={s.id} className="row" style={subRowStyle} >
                                 <div className="col-md-1" >{s.id}</div >
                                 <div className="col-md-9" >{s.name}</div >
                                 <div className="col-md-2" >
                                    {" | "}
                                    <Link to={`/product/productSub/${s.id}`} >details</Link >
                                    {" | "}
                                    <Link to={`/product/productSub/edit/${s.id}`} >edit</Link >
                                    {" | "}
                                 </div >
                              </div >
                           ))
                           : null
                     }
                  </div >
               ))}
            </div >
         </div >
      );
   }
}

export default ProductSearch;



/** WEBPACK FOOTER **
 ** ./src/components/ItemManagement/Product/ProductSearch.js
 **/